import { render, staticRenderFns } from "./GeneralInstitutionAmbience.vue?vue&type=template&id=54574e3a"
import script from "./GeneralInstitutionAmbience.vue?vue&type=script&lang=js"
export * from "./GeneralInstitutionAmbience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54574e3a')) {
      api.createRecord('54574e3a', component.options)
    } else {
      api.reload('54574e3a', component.options)
    }
    module.hot.accept("./GeneralInstitutionAmbience.vue?vue&type=template&id=54574e3a", function () {
      api.rerender('54574e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/GeneralInstitutionAmbience.vue"
export default component.exports